import { boolean } from "yup"
import { ErrorMessages } from "logics/const"

export default function booleanOptional() {
  return boolean().nullable().typeError(ErrorMessages.NotNumber)
}
